import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import AddMoradaModal from './AddMoradaModal';
import axios from 'axios';


const MoradasClient = ({ clientId, apiBaseURL }) => {
  const [moradas, setMoradas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  // Função para buscar as moradas do cliente via API com autenticação
  const fetchMoradas = () => {
    if (!clientId) return;
    setLoading(true);
    const token = localStorage.getItem("access"); // ou outro método para obter o token
    fetch(`${apiBaseURL}/moradas-dachser/?client_id=${clientId}`, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao buscar moradas');
        }
        return response.json();
      })
      .then(data => {
        setMoradas(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchMoradas();
  }, [clientId, apiBaseURL]);

  const handleAddMoradaSubmit = async (formData) => {
    if (!clientId) {
      // Se clientId for obrigatório, lança erro pra ser capturado lá em cima
      throw new Error("clientId não está definido.");
    }
  
    const payload = {
      ...formData,
      client: clientId,
      country: formData.country,
    };
    console.log("Payload a ser enviado:", payload);
  
    const token = localStorage.getItem("access");
    try {
      const { data } = await axios.post(
        `${apiBaseURL}/moradas-dachser/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Morada adicionada com sucesso:", data);
  
      // Actualiza lista e fecha modal
      fetchMoradas();
      setModalOpen(false);
  
      // Retorna mensagem de sucesso para o FeedbackModal
      return "Morada adicionada com sucesso.";
    } catch (err) {
      console.error("Erro ao adicionar morada:", err);
  
      // Re-lança o erro para ser apanhado pelo catch do handleConfirm
      throw err;
    }
  };
  return (
    <Box>
      <Button 
        variant="contained" 
        onClick={() => setModalOpen(true)}
        sx={{ mb: 2 }}
      >
        Adicionar Morada
      </Button>
      
      <AddMoradaModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleAddMoradaSubmit}
      />
      
      {loading && <Typography>Carregando moradas...</Typography>}
      {error && <Typography color="error">Erro: {error}</Typography>}
      {(!loading && moradas.length === 0) && (
        <Typography>Nenhuma morada encontrada para este cliente.</Typography>
      )}
      
      {moradas.length > 0 && (
        <Paper sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Defenicao</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Postal Code</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Suplementinformation</TableCell>
                <TableCell>Country</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {moradas.map((morada, index) => (
                <TableRow key={index}>
                  <TableCell>{morada.defenicao}</TableCell>
                  <TableCell>{morada.address}</TableCell>
                  <TableCell>{morada.postal_code}</TableCell>
                  <TableCell>{morada.city}</TableCell>
                  <TableCell>{morada.suplementinformation}</TableCell>
                  <TableCell>{morada.country}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
};

export default MoradasClient;
